import { BlogPage } from "@web/pages/blog/BlogPage";
import { PostData } from "@web/types/blog/PostData";
import { getSortedPostsData } from "@web/utils/blog/getSortedPostsData";
import { GetStaticProps } from "next";
import Head from "next/head";

export const getStaticProps: GetStaticProps = async () => {
  const allPostsData = getSortedPostsData();
  return {
    props: {
      allPostsData,
    },
  };
};

type Props = {
  allPostsData: Array<PostData>;
};

export default function Blog({ allPostsData }: Props) {
  return (
    <>
      <Head>
        <title>Harken | Blog</title>
      </Head>
      <BlogPage allPostsData={allPostsData} />
    </>
  );
}
